import React, { useId } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import IconTooltip, { sanitize_dom_id } from '../IconTooltip';

import './CardIconAction.scss';

const CardIconAction = ({
    id,
    icon,
    title,
    onClick,
    to,
    disabled = false,
    danger = false,
    className = '',
}) => {
    const generatedId = useId().replace(/:/g, '');
    const sanitizedPrefix = sanitize_dom_id(id);
    const actionId = sanitizedPrefix
        ? `${sanitizedPrefix}-${generatedId}`
        : `card-icon-action-${generatedId}`;

    return (
        <IconTooltip id={actionId} label={title}>
            <Button
                type="button"
                tag={to ? Link : 'button'}
                to={to}
                color="link"
                className={`CardIconAction ${danger ? 'CardIconAction--danger' : ''} ${className}`.trim()}
                onClick={(event) => {
                    event.stopPropagation();
                    // Prevent parent Link/CardHeader navigation when this is an action button.
                    if (onClick) {
                        event.preventDefault();
                        onClick(event);
                    }
                }}
                disabled={disabled}
            >
                <i className={`fa ${icon}`} aria-hidden="true" />
            </Button>
        </IconTooltip>
    );
};

export default CardIconAction;
